import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { desaturate, lighten, tint } from "polished";
var getPrimaryStyles = function(defaultColor, highlightColor, theme) {
    return /*#__PURE__*/ css("color:", theme.color.natural0, ";background-color:", defaultColor, ";transition:background 1s;&:hover,&:focus-visible{background-color:", highlightColor, ";background-image:radial-gradient(\n      circle,transparent 1%,", highlightColor, " 1%\n    );background-position:center;background-size:15000%;}&:active{background-color:", tint(0.15, highlightColor), ";background-size:100%;transition:background 0s;}");
};
var getPrimaryDisabledStyles = function(theme) {
    return /*#__PURE__*/ css("color:", theme.color.natural50, ";background-color:", theme.color.natural10, ";");
};
var getSecondaryStyles = function(defaultColor, highlightColor, isSmallButton, theme) {
    return /*#__PURE__*/ css("padding:", isSmallButton ? "0.5rem 0.75rem" : "0.875rem 1.875rem", ";border:2px solid currentcolor;color:", defaultColor, ";background-color:", theme.color.natural0, ";transition-property:color,background,border-color;transition-duration:1s;&:hover,&:focus-visible{color:", highlightColor, ";background-color:", theme.color.natural0, ";background-image:radial-gradient(\n      circle,transparent 1%,", theme.color.natural0, " 1%\n    );background-position:center;background-size:15000%;}&:active{color:", highlightColor, ";background-color:", tint(0.8, highlightColor), ";background-size:100%;transition:background 0s;}");
};
var getSecondaryDisabledStyles = function(isSmallButton, theme) {
    return /*#__PURE__*/ css("padding:", isSmallButton ? "0.5rem 0.875rem" : "0.875rem 1.875rem", ";border:2px solid ", theme.color.natural20, ";color:", theme.color.natural50, ";background-color:", theme.color.natural0, ";");
};
var ButtonComponent = /*#__PURE__*/ styled("button", {
    target: "ex50cky0"
})("display:", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth ? "flex" : "inline-flex";
}, ";flex-direction:", function(param) {
    var iconAlignment = param.iconAlignment;
    return iconAlignment === "right" ? "row-reverse" : "";
}, ";justify-content:center;align-items:center;gap:0.5rem;margin:0;padding:", function(param) {
    var isSmallButton = param.isSmallButton;
    return isSmallButton ? "0.625rem 1rem" : "1rem 2rem";
}, ";border:0;outline:0;border-radius:0.5rem;overflow:visible;box-sizing:border-box;width:", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth ? "100%" : "";
}, ";max-width:100%;white-space:nowrap;text-decoration:none;text-transform:none;fill:currentcolor;background-position:center;-webkit-tap-highlight-color:transparent;cursor:", function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "not-allowed" : "pointer";
}, ";user-select:none;appearance:none;", function(param) {
    var theme = param.theme, isSecondaryButton = param.isSecondaryButton, isSmallButton = param.isSmallButton, isDisabled = param.isDisabled;
    var defaultColor = theme.color.primary;
    var highlightColor = lighten(0.3, desaturate(0.6, defaultColor));
    if (isSecondaryButton) {
        if (isDisabled) {
            return getSecondaryDisabledStyles(isSmallButton, theme);
        }
        return getSecondaryStyles(defaultColor, highlightColor, isSmallButton, theme);
    }
    if (isDisabled) {
        return getPrimaryDisabledStyles(theme);
    }
    return getPrimaryStyles(defaultColor, highlightColor, theme);
}, ";");
export { ButtonComponent };
